/* 布局 */
//前台
import Layout from "@views/layout";

const propertyRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "property",
            name: "PROPERTY",
            meta: {
                title: "资产管理",
                sort: 1,
            },
            component: () => import("@views/business/property/index.vue"),
            redirect: {
                name: "PROPERTY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "PROPERTY_LIST",
                    meta: {
                        title: "资产管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/property/list.vue"),
                },
                                {
                    path: "add",
                    name: "PROPERTY_ADD",
                    meta: {
                        title: "新增资产管理",
                        parentPath: '/business/property/list',
                        operate: true,
                    },
                    component: () => import("@views/business/property/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "PROPERTY_EDIT",
                    meta: {
                        title: "编辑资产管理",
                        parentPath: '/business/property/list',
                        operate: true,
                    },
                    component: () => import("@views/business/property/form.vue"),
                },
                                        ],
    },


        ],
};

export default propertyRouter;
